export enum GaConstants {
    BOX = 'box',
    TABLE = 'table',
    SLIDER = 'slider',
}

export const GA_NEWSLETTER = {
    MY_ACCOUNT: 'my_account',
    VALUE_YES: 'Yes, please send me these offers',
    VALUE_NO: 'No, please do not send me these offers'
};